import React, { useEffect, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
import history from '../../../history';
import TextField from '@material-ui/core/TextField';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const UpdateProfile = (props) => {

    const [profile, setProfile] = useState({});
    const [nameProfile, setNameProfile] = useState('');
    const [codProflie, setCodProfile] = useState('');

    useEffect(() => {
        setProfile(props.location.state.profile);
        setNameProfile(props.location.state.profile.nombre);
        setCodProfile(props.location.state.profile.codigo);
    }, []);


    const upProfile = async () => {

        let data = {
            id_perfil: profile.id_perfil,
            nombre: nameProfile,
            codigo: codProflie,
            perfil: profile.perfil
        };

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'perfiles/update',
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
            .then(response => {
                return response.text();
            })
            .then(data => {

                alert("Perfil actualizado correctamente");
                history.push({
                    pathname: process.env.PUBLIC_URL + '/config/manage-profile',
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 style={{ marginBottom: 30 }}>Actualizar Perfil</h3>
                    <Button
                        style={{ marginBottom: 20 }}
                        color="primary"
                        size="sm"
                        onClick={() => {
                            history.push({
                                pathname: process.env.PUBLIC_URL + '/config/manage-profile'
                            });
                        }}
                    >
                        <ArrowBackIcon />
                    </Button>
                </Col>
            </Row>
            <Row>
                <Card>
                    <CardBody style={{ margin: 'auto' }}>
                        <div className="form" style={{ display: 'inline' }}>
                            <div className="form__form-group">
                                <div className="form__form-group-field">
                                    <TextField
                                        required
                                        className="material-form__field"
                                        id="id-name-profile"
                                        label="Nombre del Perfil"
                                        type="text"
                                        style={{ width: 400 }}
                                        value={nameProfile}
                                        onChange={(e) => {
                                            setNameProfile(e.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <div className="form__form-group-field">
                                    <TextField
                                        required
                                        className="material-form__field"
                                        id="id-code-profile"
                                        label="Nombre del Perfil"
                                        type="text"
                                        style={{ width: 400 }}
                                        value={codProflie}
                                        onChange={(e) => {
                                            setCodProfile(e.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <Button
                            style={{ marginTop: 20 }}
                            color="primary"
                            onClick={() => {
                                upProfile();
                            }}
                        >
                            Actualizar
                        </Button>
                    </CardBody>
                </Card>
            </Row>
        </Container>);
}

export default reduxForm({
    form: 'update_profile_form', // a unique identifier for this form
})(withTranslation('common')(UpdateProfile));